export const BookingCard = `
<!DOCTYPE html>
<html>
    <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
    </head>
    <body>
        <a href="##BOOKING_LINK##">##BOOKING_TITLE## ##BOOKING_DETAILS##</a>
    </body>
</html>`;

export const BookingPageDetails = `
<tr style="width: 100%">
    <td valign="top" class="eventDetailsContainer" style="padding-left: 12px; padding-bottom: 12px; vertical-align: top; font-size: 14px; color: #797775; font-weight: bold; font-family: "Segoe UI";">
        ##DISPLAY_NAME##
    </td>
</tr>`;

export const MeetingTypeDetails = `
<tr style="width: 100%">
    <td valign="top" class="eventDetailsContainer" style="padding-left: 12px; vertical-align: top; font-size: 12px; color: #797775; font-weight: bold; font-family: "Segoe UI";">
        ##DISPLAY_NAME##
    </td>
</tr>
<tr style="width: 100%">
    <td valign="top" class="eventDetailsContainer" style="padding-left: 12px; vertical-align: top; font-size: 12px; color: #797775; font-weight: bold; font-family: &quot;Segoe UI&quot;">
        ##PERSONAL_BOOKING##
    </td>
</tr>
<tr style="width: 100%">
    <td style="padding-left: 12px; padding-top: 6px; vertical-align: top; font-size: 16px; font-weight: bold; font-family: Segoe UI; ">
        ##MEETING_TYPE_DETAILS##
    </td>
</tr>
##MEETING_DETAIL_DESCRIPTION##

##MEETING_AVAILABILITY_DETAILS## `;

export const MeetingAvailability = `
<tr height="20">
    <td style="padding-left: 12px; padding-bottom: 12px; vertical-align: top; box-sizing: border-box; font-weight: bold; font-family: Segoe UI; font-size: 10px; color: #605E5C;">
        ##MEETING_AVAILABILITY##
    </td>
</tr>`;

export const MeetingDescription = `
<tr height="20">
    <td style="padding-left: 12px; padding-bottom: 12px; vertical-align: top; box-sizing: border-box; font-weight: bold; font-family: Segoe UI; font-size: 14px; color: #605E5C;">
        ##MEETING_TYPE_DESCRIPTION##
    </td>
</tr>`;
